import { useState, useRef, useEffect, Fragment } from 'react'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'
import styles from './dropdown.module.scss'
import AddIcon from '@mui/icons-material/Add'

export default function DropdownButton({
	label = 'Select',
	options = [],
	onSelect,
	variant = 'default',
	size = 'md',
	showArrow = true,
	children,
	mainClassName = '',
	pluseIcon = false,
	...rest
}) {
	const [open, setOpen] = useState(false)
	const [position, setPosition] = useState('bottom-left') // default
	const dropdownRef = useRef(null)
	const buttonRef = useRef(null)

	useEffect(() => {
		const handleClickOutside = (e) => {
			if (
				dropdownRef.current &&
				!dropdownRef.current.contains(e.target) &&
				!buttonRef.current.contains(e.target)
			) {
				setOpen(false)
			}
		}
		document.addEventListener('mousedown', handleClickOutside)
		return () =>
			document.removeEventListener('mousedown', handleClickOutside)
	}, [])

	const toggleDropdown = () => {
		if (!open && buttonRef.current) {
			const rect = buttonRef.current.getBoundingClientRect()
			const viewportW = window.innerWidth
			const viewportH = window.innerHeight
			const vertical = rect.bottom + 200 > viewportH ? 'top' : 'bottom'
			const horizontal = rect.right > viewportW / 2 ? 'right' : 'left'

			setPosition(`${vertical}-${horizontal}`)
		}
		setOpen(!open)
	}

	const handleSelect = (option) => {
		setOpen(false)
		if (onSelect) onSelect(option)
	}

	return (
		<div className={styles.wrapper} ref={dropdownRef}>
			<button
				ref={buttonRef}
				className={`${styles.button} ${styles[variant]} ${styles[size]} ${open ? styles.active : ''} ${mainClassName}`}
				onClick={toggleDropdown}
				{...rest}
			>
				<span>
					{pluseIcon && (
						<AddIcon
							sx={{ marginRight: '8px' }}
							width={16}
							height={16}
						/>
					)}
					{label}
				</span>
				{showArrow &&
					(open ? (
						<span className={styles.chevron}>
							<KeyboardArrowUpIcon />
						</span>
					) : (
						<span className={styles.chevron}>
							<KeyboardArrowDownIcon />
						</span>
					))}
			</button>

			{open && (
				<div className={`${styles.menu} ${styles[position]}`}>
					{options?.length > 0 &&
						options.map((el) => (
							<Fragment key={el.label}>
								<button onClick={() => handleSelect(el)}>
									{el?.imgSrc && el?.imgBefore && (
										<img
											src={el?.imgSrc}
											alt={el?.label}
											loading="lazy"
										/>
									)}{' '}
									<span>{el.label}</span>{' '}
									{el?.imgSrc && el?.imgAfter && (
										<img
											src={el?.imgSrc}
											alt={el?.label}
											loading="lazy"
										/>
									)}
								</button>
								{el?.showDivider && (
									<div className={styles.divider}></div>
								)}
							</Fragment>
						))}
				</div>
			)}
		</div>
	)
}
